import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import makeStyles from "@material-ui/styles/makeStyles";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
	root: {
		[theme.breakpoints.up("md")]: {
			display: "grid",
			gridColumnGap: theme.spacing(6),
			gridTemplateColumns: "1fr 1fr"
		}
	},
	headline: {
		color: theme.palette.secondary.main,
		marginBottom: theme.spacing(2),
		[theme.breakpoints.up("md")]: {
			margin: theme.spacing(0)
		}
	}
}));

const HeadlineTextCombi = ({ headline, text }) => {
	const css = useStyles();

	return (
		<div className={clsx("extension-headline-text-combi", css.root)}>
			<Typography
				className={clsx("extension-headline-text-combi__text", css.headline)}
				component="h2"
				dangerouslySetInnerHTML={{ __html: headline }}
				variant="h3"
			/>
			<Typography
				className={clsx("extension-headline-text-combi__text", css.text)}
				component="div"
				dangerouslySetInnerHTML={{ __html: text }}
				variant="body1"
			/>
		</div>
	);
};

HeadlineTextCombi.propTypes = {
	headline: PropTypes.string.isRequired
};

export default HeadlineTextCombi;
